<template>
  <section>
    <permission-group-list :query="query" />
  </section>
</template>

<script>
import PermissionGroupList from '@/components/system/PermissionGroupList'

export default {
  name: 'PermissionGroups',
  components: {
    PermissionGroupList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
